import { useCallback, useContext, useEffect, useRef } from "react"
import { useFormDispatch, useFormSelector } from "../../../redux/formStoreHooks"
import { selectLabRows, updateLabByIdx } from "../../../redux/labsSlice"
import { V2L3LabsTable } from "./V2L3LabsTable"
import { BarcodeType } from '@fusion-advantage/backcompat'
import { LabActionType, LabItemAction, LabItemBMDAction, newLabItemBMDAction } from "@fusion-advantage/formlib"
import { useBarcodeScannerPlugin } from "../../../lib/useNativePlugin"
import L6FormContext from "../../form/l6/L6FormContext"

interface V2LxLabsTableProps {
	xpath?: string
}

export const V2LxLabsTable = ({xpath}: V2LxLabsTableProps) => {
	const rows = useFormSelector(selectLabRows)
	const platform = useFormSelector(state => state.render.platform)
	const dispatch = useFormDispatch()
	const handleActionChange = useCallback((stateIdx: number, action: LabItemAction) => {
		dispatch(updateLabByIdx({
			stateIdx,
			model: {
				action,
			},
		}))
	}, [dispatch])
	const handleBmdActionChange = useCallback((stateIdx: number, action: Partial<LabItemBMDAction>) => {
		dispatch(updateLabByIdx({
			stateIdx,
			model: {
				action: {
					...newLabItemBMDAction(),
					...action,
				},
			},
		}))
	}, [dispatch])
	const scanningIdxRef = useRef<number|null>(null)
	const handleScanReceive = useCallback((code: string) => {
		dispatch(updateLabByIdx({
			stateIdx: scanningIdxRef.current!,
			model: {
				action: {
					type: LabActionType.Codes,
					code: code?.toUpperCase(),
				}
			},
		}))
	}, [])
	const { showBarcodeScanner } = useBarcodeScannerPlugin({
		onReceive: handleScanReceive,
	})
	const handleScanClick = useCallback((stateIdx: number) => {
		scanningIdxRef.current = stateIdx
		showBarcodeScanner({barcodeType: BarcodeType.QR})
	}, [showBarcodeScanner])
	const { setXpathValuedDeterminer } = useContext(L6FormContext)

	const shouldPrint = rows.some(x => x.model.action !== null || x.model.required)

	useEffect(() => {
		if(xpath && shouldPrint) {
			setXpathValuedDeterminer(xpath, true)
			return () => {
				setXpathValuedDeterminer(xpath, false)
			}
		}
	}, [xpath, setXpathValuedDeterminer, shouldPrint ])
	
	return (
		<V2L3LabsTable
			rows={rows}
			platform={platform}
			onActionChange={handleActionChange}
			onBmdActionChange={handleBmdActionChange}
			onScanClick={handleScanClick}
		/>
	)
}
